/* tslint:disable */

/* eslint-disable */

/**
 * SaasReport.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

// @ts-ignore
import { ReportTaAvailableCountCompareBy } from '../api-models';
// @ts-ignore
import { ReportTaFileFormat } from '../api-models';
// @ts-ignore
import { ReportTaGroupBy } from '../api-models';
// @ts-ignore
import { ReportTaOrientation } from '../api-models';
// @ts-ignore
import { ReportTaSortEnum } from '../api-models';
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';

/**
 * SaaSReportsReportApi - axios parameter creator
 * @export
 */
export const SaaSReportsReportApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {number} departmentId
     * @param {number} shiftTypeId
     * @param {number} positionId
     * @param {string} startDate
     * @param {string} endDate
     * @param {ReportTaFileFormat} format
     * @param {boolean} [displayTotals]
     * @param {ReportTaAvailableCountCompareBy} [availableCountCompareBy]
     * @param {number} [facilityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saaSReportsAvailableSchedulesGet: async (
      departmentId: number,
      shiftTypeId: number,
      positionId: number,
      startDate: string,
      endDate: string,
      format: ReportTaFileFormat,
      displayTotals?: boolean,
      availableCountCompareBy?: ReportTaAvailableCountCompareBy,
      facilityId?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'departmentId' is not null or undefined
      assertParamExists(
        'saaSReportsAvailableSchedulesGet',
        'departmentId',
        departmentId
      );
      // verify required parameter 'shiftTypeId' is not null or undefined
      assertParamExists(
        'saaSReportsAvailableSchedulesGet',
        'shiftTypeId',
        shiftTypeId
      );
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists(
        'saaSReportsAvailableSchedulesGet',
        'positionId',
        positionId
      );
      // verify required parameter 'startDate' is not null or undefined
      assertParamExists(
        'saaSReportsAvailableSchedulesGet',
        'startDate',
        startDate
      );
      // verify required parameter 'endDate' is not null or undefined
      assertParamExists('saaSReportsAvailableSchedulesGet', 'endDate', endDate);
      // verify required parameter 'format' is not null or undefined
      assertParamExists('saaSReportsAvailableSchedulesGet', 'format', format);
      const localVarPath = `/SaaSReports/available-schedules`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (departmentId !== undefined) {
        localVarQueryParameter['DepartmentId'] = departmentId;
      }

      if (shiftTypeId !== undefined) {
        localVarQueryParameter['ShiftTypeId'] = shiftTypeId;
      }

      if (positionId !== undefined) {
        localVarQueryParameter['PositionId'] = positionId;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['StartDate'] =
          (startDate as any) instanceof Date
            ? (startDate as any).toISOString()
            : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['EndDate'] =
          (endDate as any) instanceof Date
            ? (endDate as any).toISOString()
            : endDate;
      }

      if (format !== undefined) {
        localVarQueryParameter['Format'] = format;
      }

      if (displayTotals !== undefined) {
        localVarQueryParameter['DisplayTotals'] = displayTotals;
      }

      if (availableCountCompareBy !== undefined) {
        localVarQueryParameter['AvailableCountCompareBy'] =
          availableCountCompareBy;
      }

      if (facilityId !== undefined) {
        localVarQueryParameter['FacilityId'] = facilityId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary GetDaily Staffing Sheet
     * @param {number} departmentId
     * @param {string} date
     * @param {number} [facilityID]
     * @param {ReportTaFileFormat} [format]
     * @param {ReportTaGroupBy} [groupBy]
     * @param {ReportTaOrientation} [orientation]
     * @param {string} [header]
     * @param {string} [footer]
     * @param {boolean} [hppdByPosition]
     * @param {boolean} [compact]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saaSReportsDailyStaffingSheetGet: async (
      departmentId: number,
      date: string,
      facilityID?: number,
      format?: ReportTaFileFormat,
      groupBy?: ReportTaGroupBy,
      orientation?: ReportTaOrientation,
      header?: string,
      footer?: string,
      hppdByPosition?: boolean,
      compact?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'departmentId' is not null or undefined
      assertParamExists(
        'saaSReportsDailyStaffingSheetGet',
        'departmentId',
        departmentId
      );
      // verify required parameter 'date' is not null or undefined
      assertParamExists('saaSReportsDailyStaffingSheetGet', 'date', date);
      const localVarPath = `/SaaSReports/daily-staffing-sheet`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (departmentId !== undefined) {
        localVarQueryParameter['departmentId'] = departmentId;
      }

      if (date !== undefined) {
        localVarQueryParameter['date'] =
          (date as any) instanceof Date ? (date as any).toISOString() : date;
      }

      if (facilityID !== undefined) {
        localVarQueryParameter['facilityID'] = facilityID;
      }

      if (format !== undefined) {
        localVarQueryParameter['format'] = format;
      }

      if (groupBy !== undefined) {
        localVarQueryParameter['groupBy'] = groupBy;
      }

      if (orientation !== undefined) {
        localVarQueryParameter['orientation'] = orientation;
      }

      if (header !== undefined) {
        localVarQueryParameter['header'] = header;
      }

      if (footer !== undefined) {
        localVarQueryParameter['footer'] = footer;
      }

      if (hppdByPosition !== undefined) {
        localVarQueryParameter['hppdByPosition'] = hppdByPosition;
      }

      if (compact !== undefined) {
        localVarQueryParameter['compact'] = compact;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Generates Master-Schedule report
     * @param {string} startDate
     * @param {string} endDate
     * @param {number} departmentId
     * @param {number} [shiftTypeId]
     * @param {number} [unitId]
     * @param {number} [positionId]
     * @param {ReportTaFileFormat} [format]
     * @param {number} [orderBy]
     * @param {number} [facilityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saaSReportsMasterScheduleGet: async (
      startDate: string,
      endDate: string,
      departmentId: number,
      shiftTypeId?: number,
      unitId?: number,
      positionId?: number,
      format?: ReportTaFileFormat,
      orderBy?: number,
      facilityId?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'startDate' is not null or undefined
      assertParamExists('saaSReportsMasterScheduleGet', 'startDate', startDate);
      // verify required parameter 'endDate' is not null or undefined
      assertParamExists('saaSReportsMasterScheduleGet', 'endDate', endDate);
      // verify required parameter 'departmentId' is not null or undefined
      assertParamExists(
        'saaSReportsMasterScheduleGet',
        'departmentId',
        departmentId
      );
      const localVarPath = `/SaaSReports/master-schedule`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (startDate !== undefined) {
        localVarQueryParameter['StartDate'] =
          (startDate as any) instanceof Date
            ? (startDate as any).toISOString()
            : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['EndDate'] =
          (endDate as any) instanceof Date
            ? (endDate as any).toISOString()
            : endDate;
      }

      if (departmentId !== undefined) {
        localVarQueryParameter['DepartmentId'] = departmentId;
      }

      if (shiftTypeId !== undefined) {
        localVarQueryParameter['ShiftTypeId'] = shiftTypeId;
      }

      if (unitId !== undefined) {
        localVarQueryParameter['UnitId'] = unitId;
      }

      if (positionId !== undefined) {
        localVarQueryParameter['PositionId'] = positionId;
      }

      if (format !== undefined) {
        localVarQueryParameter['Format'] = format;
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['OrderBy'] = orderBy;
      }

      if (facilityId !== undefined) {
        localVarQueryParameter['FacilityId'] = facilityId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Monthly print report.
     * @param {string} startDate
     * @param {string} endDate
     * @param {number} departmentId
     * @param {number} [shiftTypeId]
     * @param {number} [unitId]
     * @param {number} [positionId]
     * @param {number} [employeeId]
     * @param {number} [facilityId]
     * @param {ReportTaFileFormat} [format]
     * @param {number} [orderBy]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saaSReportsMonthlyPrintGet: async (
      startDate: string,
      endDate: string,
      departmentId: number,
      shiftTypeId?: number,
      unitId?: number,
      positionId?: number,
      employeeId?: number,
      facilityId?: number,
      format?: ReportTaFileFormat,
      orderBy?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'startDate' is not null or undefined
      assertParamExists('saaSReportsMonthlyPrintGet', 'startDate', startDate);
      // verify required parameter 'endDate' is not null or undefined
      assertParamExists('saaSReportsMonthlyPrintGet', 'endDate', endDate);
      // verify required parameter 'departmentId' is not null or undefined
      assertParamExists(
        'saaSReportsMonthlyPrintGet',
        'departmentId',
        departmentId
      );
      const localVarPath = `/SaaSReports/monthly-print`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (startDate !== undefined) {
        localVarQueryParameter['StartDate'] =
          (startDate as any) instanceof Date
            ? (startDate as any).toISOString()
            : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['EndDate'] =
          (endDate as any) instanceof Date
            ? (endDate as any).toISOString()
            : endDate;
      }

      if (departmentId !== undefined) {
        localVarQueryParameter['DepartmentId'] = departmentId;
      }

      if (shiftTypeId !== undefined) {
        localVarQueryParameter['ShiftTypeId'] = shiftTypeId;
      }

      if (unitId !== undefined) {
        localVarQueryParameter['UnitId'] = unitId;
      }

      if (positionId !== undefined) {
        localVarQueryParameter['PositionId'] = positionId;
      }

      if (employeeId !== undefined) {
        localVarQueryParameter['EmployeeId'] = employeeId;
      }

      if (facilityId !== undefined) {
        localVarQueryParameter['FacilityId'] = facilityId;
      }

      if (format !== undefined) {
        localVarQueryParameter['Format'] = format;
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['OrderBy'] = orderBy;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Dashboard Print Report
     * @param {string} date
     * @param {number} [departmentId]
     * @param {number} [positionId]
     * @param {number} [facilityId]
     * @param {ReportTaFileFormat} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saaSReportsPrintDashboardGet: async (
      date: string,
      departmentId?: number,
      positionId?: number,
      facilityId?: number,
      format?: ReportTaFileFormat,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'date' is not null or undefined
      assertParamExists('saaSReportsPrintDashboardGet', 'date', date);
      const localVarPath = `/SaaSReports/print-dashboard`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (date !== undefined) {
        localVarQueryParameter['Date'] =
          (date as any) instanceof Date ? (date as any).toISOString() : date;
      }

      if (departmentId !== undefined) {
        localVarQueryParameter['DepartmentId'] = departmentId;
      }

      if (positionId !== undefined) {
        localVarQueryParameter['PositionId'] = positionId;
      }

      if (facilityId !== undefined) {
        localVarQueryParameter['FacilityId'] = facilityId;
      }

      if (format !== undefined) {
        localVarQueryParameter['Format'] = format;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {number} [schedulePeriodId]
     * @param {boolean} [usingSchedulePeriod]
     * @param {number} [employeeId]
     * @param {number} [facilityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saaSReportsPrintEmployeeViewGet: async (
      startDate?: string,
      endDate?: string,
      schedulePeriodId?: number,
      usingSchedulePeriod?: boolean,
      employeeId?: number,
      facilityId?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/SaaSReports/print-employee-view`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (startDate !== undefined) {
        localVarQueryParameter['StartDate'] =
          (startDate as any) instanceof Date
            ? (startDate as any).toISOString()
            : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['EndDate'] =
          (endDate as any) instanceof Date
            ? (endDate as any).toISOString()
            : endDate;
      }

      if (schedulePeriodId !== undefined) {
        localVarQueryParameter['SchedulePeriodId'] = schedulePeriodId;
      }

      if (usingSchedulePeriod !== undefined) {
        localVarQueryParameter['UsingSchedulePeriod'] = usingSchedulePeriod;
      }

      if (employeeId !== undefined) {
        localVarQueryParameter['EmployeeId'] = employeeId;
      }

      if (facilityId !== undefined) {
        localVarQueryParameter['FacilityId'] = facilityId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Master Schedule Planner Print Report
     * @param {number} departmentId
     * @param {number} [shiftTypeId]
     * @param {number} [positionId]
     * @param {number} [masterScheduleDraftId]
     * @param {number} [facilityId]
     * @param {ReportTaFileFormat} [format]
     * @param {number} [numberOfWeeks]
     * @param {ReportTaSortEnum} [unitSort]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saaSReportsPrintMasterSchedulePlannerGet: async (
      departmentId: number,
      shiftTypeId?: number,
      positionId?: number,
      masterScheduleDraftId?: number,
      facilityId?: number,
      format?: ReportTaFileFormat,
      numberOfWeeks?: number,
      unitSort?: ReportTaSortEnum,
      search?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'departmentId' is not null or undefined
      assertParamExists(
        'saaSReportsPrintMasterSchedulePlannerGet',
        'departmentId',
        departmentId
      );
      const localVarPath = `/SaaSReports/print-master-schedule-planner`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (departmentId !== undefined) {
        localVarQueryParameter['DepartmentId'] = departmentId;
      }

      if (shiftTypeId !== undefined) {
        localVarQueryParameter['ShiftTypeId'] = shiftTypeId;
      }

      if (positionId !== undefined) {
        localVarQueryParameter['PositionId'] = positionId;
      }

      if (masterScheduleDraftId !== undefined) {
        localVarQueryParameter['MasterScheduleDraftId'] = masterScheduleDraftId;
      }

      if (facilityId !== undefined) {
        localVarQueryParameter['FacilityId'] = facilityId;
      }

      if (format !== undefined) {
        localVarQueryParameter['Format'] = format;
      }

      if (numberOfWeeks !== undefined) {
        localVarQueryParameter['NumberOfWeeks'] = numberOfWeeks;
      }

      if (unitSort !== undefined) {
        localVarQueryParameter['UnitSort'] = unitSort;
      }

      if (search !== undefined) {
        localVarQueryParameter['Search'] = search;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SaaSReportsReportApi - functional programming interface
 * @export
 */
export const SaaSReportsReportApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    SaaSReportsReportApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} departmentId
     * @param {number} shiftTypeId
     * @param {number} positionId
     * @param {string} startDate
     * @param {string} endDate
     * @param {ReportTaFileFormat} format
     * @param {boolean} [displayTotals]
     * @param {ReportTaAvailableCountCompareBy} [availableCountCompareBy]
     * @param {number} [facilityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saaSReportsAvailableSchedulesGet(
      departmentId: number,
      shiftTypeId: number,
      positionId: number,
      startDate: string,
      endDate: string,
      format: ReportTaFileFormat,
      displayTotals?: boolean,
      availableCountCompareBy?: ReportTaAvailableCountCompareBy,
      facilityId?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.saaSReportsAvailableSchedulesGet(
          departmentId,
          shiftTypeId,
          positionId,
          startDate,
          endDate,
          format,
          displayTotals,
          availableCountCompareBy,
          facilityId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary GetDaily Staffing Sheet
     * @param {number} departmentId
     * @param {string} date
     * @param {number} [facilityID]
     * @param {ReportTaFileFormat} [format]
     * @param {ReportTaGroupBy} [groupBy]
     * @param {ReportTaOrientation} [orientation]
     * @param {string} [header]
     * @param {string} [footer]
     * @param {boolean} [hppdByPosition]
     * @param {boolean} [compact]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saaSReportsDailyStaffingSheetGet(
      departmentId: number,
      date: string,
      facilityID?: number,
      format?: ReportTaFileFormat,
      groupBy?: ReportTaGroupBy,
      orientation?: ReportTaOrientation,
      header?: string,
      footer?: string,
      hppdByPosition?: boolean,
      compact?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.saaSReportsDailyStaffingSheetGet(
          departmentId,
          date,
          facilityID,
          format,
          groupBy,
          orientation,
          header,
          footer,
          hppdByPosition,
          compact,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Generates Master-Schedule report
     * @param {string} startDate
     * @param {string} endDate
     * @param {number} departmentId
     * @param {number} [shiftTypeId]
     * @param {number} [unitId]
     * @param {number} [positionId]
     * @param {ReportTaFileFormat} [format]
     * @param {number} [orderBy]
     * @param {number} [facilityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saaSReportsMasterScheduleGet(
      startDate: string,
      endDate: string,
      departmentId: number,
      shiftTypeId?: number,
      unitId?: number,
      positionId?: number,
      format?: ReportTaFileFormat,
      orderBy?: number,
      facilityId?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.saaSReportsMasterScheduleGet(
          startDate,
          endDate,
          departmentId,
          shiftTypeId,
          unitId,
          positionId,
          format,
          orderBy,
          facilityId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Monthly print report.
     * @param {string} startDate
     * @param {string} endDate
     * @param {number} departmentId
     * @param {number} [shiftTypeId]
     * @param {number} [unitId]
     * @param {number} [positionId]
     * @param {number} [employeeId]
     * @param {number} [facilityId]
     * @param {ReportTaFileFormat} [format]
     * @param {number} [orderBy]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saaSReportsMonthlyPrintGet(
      startDate: string,
      endDate: string,
      departmentId: number,
      shiftTypeId?: number,
      unitId?: number,
      positionId?: number,
      employeeId?: number,
      facilityId?: number,
      format?: ReportTaFileFormat,
      orderBy?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.saaSReportsMonthlyPrintGet(
          startDate,
          endDate,
          departmentId,
          shiftTypeId,
          unitId,
          positionId,
          employeeId,
          facilityId,
          format,
          orderBy,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Dashboard Print Report
     * @param {string} date
     * @param {number} [departmentId]
     * @param {number} [positionId]
     * @param {number} [facilityId]
     * @param {ReportTaFileFormat} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saaSReportsPrintDashboardGet(
      date: string,
      departmentId?: number,
      positionId?: number,
      facilityId?: number,
      format?: ReportTaFileFormat,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.saaSReportsPrintDashboardGet(
          date,
          departmentId,
          positionId,
          facilityId,
          format,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {number} [schedulePeriodId]
     * @param {boolean} [usingSchedulePeriod]
     * @param {number} [employeeId]
     * @param {number} [facilityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saaSReportsPrintEmployeeViewGet(
      startDate?: string,
      endDate?: string,
      schedulePeriodId?: number,
      usingSchedulePeriod?: boolean,
      employeeId?: number,
      facilityId?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.saaSReportsPrintEmployeeViewGet(
          startDate,
          endDate,
          schedulePeriodId,
          usingSchedulePeriod,
          employeeId,
          facilityId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Master Schedule Planner Print Report
     * @param {number} departmentId
     * @param {number} [shiftTypeId]
     * @param {number} [positionId]
     * @param {number} [masterScheduleDraftId]
     * @param {number} [facilityId]
     * @param {ReportTaFileFormat} [format]
     * @param {number} [numberOfWeeks]
     * @param {ReportTaSortEnum} [unitSort]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saaSReportsPrintMasterSchedulePlannerGet(
      departmentId: number,
      shiftTypeId?: number,
      positionId?: number,
      masterScheduleDraftId?: number,
      facilityId?: number,
      format?: ReportTaFileFormat,
      numberOfWeeks?: number,
      unitSort?: ReportTaSortEnum,
      search?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.saaSReportsPrintMasterSchedulePlannerGet(
          departmentId,
          shiftTypeId,
          positionId,
          masterScheduleDraftId,
          facilityId,
          format,
          numberOfWeeks,
          unitSort,
          search,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * SaaSReportsReportApi - factory interface
 * @export
 */
export const SaaSReportsReportApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SaaSReportsReportApiFp(configuration);
  return {
    /**
     *
     * @param {SaaSReportsReportApiSaaSReportsAvailableSchedulesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saaSReportsAvailableSchedulesGet(
      requestParameters: SaaSReportsReportApiSaaSReportsAvailableSchedulesGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .saaSReportsAvailableSchedulesGet(
          requestParameters.departmentId,
          requestParameters.shiftTypeId,
          requestParameters.positionId,
          requestParameters.startDate,
          requestParameters.endDate,
          requestParameters.format,
          requestParameters.displayTotals,
          requestParameters.availableCountCompareBy,
          requestParameters.facilityId,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary GetDaily Staffing Sheet
     * @param {SaaSReportsReportApiSaaSReportsDailyStaffingSheetGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saaSReportsDailyStaffingSheetGet(
      requestParameters: SaaSReportsReportApiSaaSReportsDailyStaffingSheetGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .saaSReportsDailyStaffingSheetGet(
          requestParameters.departmentId,
          requestParameters.date,
          requestParameters.facilityID,
          requestParameters.format,
          requestParameters.groupBy,
          requestParameters.orientation,
          requestParameters.header,
          requestParameters.footer,
          requestParameters.hppdByPosition,
          requestParameters.compact,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Generates Master-Schedule report
     * @param {SaaSReportsReportApiSaaSReportsMasterScheduleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saaSReportsMasterScheduleGet(
      requestParameters: SaaSReportsReportApiSaaSReportsMasterScheduleGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .saaSReportsMasterScheduleGet(
          requestParameters.startDate,
          requestParameters.endDate,
          requestParameters.departmentId,
          requestParameters.shiftTypeId,
          requestParameters.unitId,
          requestParameters.positionId,
          requestParameters.format,
          requestParameters.orderBy,
          requestParameters.facilityId,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Monthly print report.
     * @param {SaaSReportsReportApiSaaSReportsMonthlyPrintGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saaSReportsMonthlyPrintGet(
      requestParameters: SaaSReportsReportApiSaaSReportsMonthlyPrintGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .saaSReportsMonthlyPrintGet(
          requestParameters.startDate,
          requestParameters.endDate,
          requestParameters.departmentId,
          requestParameters.shiftTypeId,
          requestParameters.unitId,
          requestParameters.positionId,
          requestParameters.employeeId,
          requestParameters.facilityId,
          requestParameters.format,
          requestParameters.orderBy,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Dashboard Print Report
     * @param {SaaSReportsReportApiSaaSReportsPrintDashboardGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saaSReportsPrintDashboardGet(
      requestParameters: SaaSReportsReportApiSaaSReportsPrintDashboardGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .saaSReportsPrintDashboardGet(
          requestParameters.date,
          requestParameters.departmentId,
          requestParameters.positionId,
          requestParameters.facilityId,
          requestParameters.format,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SaaSReportsReportApiSaaSReportsPrintEmployeeViewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saaSReportsPrintEmployeeViewGet(
      requestParameters: SaaSReportsReportApiSaaSReportsPrintEmployeeViewGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .saaSReportsPrintEmployeeViewGet(
          requestParameters.startDate,
          requestParameters.endDate,
          requestParameters.schedulePeriodId,
          requestParameters.usingSchedulePeriod,
          requestParameters.employeeId,
          requestParameters.facilityId,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Master Schedule Planner Print Report
     * @param {SaaSReportsReportApiSaaSReportsPrintMasterSchedulePlannerGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saaSReportsPrintMasterSchedulePlannerGet(
      requestParameters: SaaSReportsReportApiSaaSReportsPrintMasterSchedulePlannerGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .saaSReportsPrintMasterSchedulePlannerGet(
          requestParameters.departmentId,
          requestParameters.shiftTypeId,
          requestParameters.positionId,
          requestParameters.masterScheduleDraftId,
          requestParameters.facilityId,
          requestParameters.format,
          requestParameters.numberOfWeeks,
          requestParameters.unitSort,
          requestParameters.search,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for saaSReportsAvailableSchedulesGet operation in SaaSReportsReportApi.
 * @export
 * @interface SaaSReportsReportApiSaaSReportsAvailableSchedulesGetRequest
 */
export interface SaaSReportsReportApiSaaSReportsAvailableSchedulesGetRequest {
  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsAvailableSchedulesGet
   */
  readonly departmentId: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsAvailableSchedulesGet
   */
  readonly shiftTypeId: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsAvailableSchedulesGet
   */
  readonly positionId: number;

  /**
   *
   * @type {string}
   * @memberof SaaSReportsReportApiSaaSReportsAvailableSchedulesGet
   */
  readonly startDate: string;

  /**
   *
   * @type {string}
   * @memberof SaaSReportsReportApiSaaSReportsAvailableSchedulesGet
   */
  readonly endDate: string;

  /**
   *
   * @type {ReportTaFileFormat}
   * @memberof SaaSReportsReportApiSaaSReportsAvailableSchedulesGet
   */
  readonly format: ReportTaFileFormat;

  /**
   *
   * @type {boolean}
   * @memberof SaaSReportsReportApiSaaSReportsAvailableSchedulesGet
   */
  readonly displayTotals?: boolean;

  /**
   *
   * @type {ReportTaAvailableCountCompareBy}
   * @memberof SaaSReportsReportApiSaaSReportsAvailableSchedulesGet
   */
  readonly availableCountCompareBy?: ReportTaAvailableCountCompareBy;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsAvailableSchedulesGet
   */
  readonly facilityId?: number;
}

/**
 * Request parameters for saaSReportsDailyStaffingSheetGet operation in SaaSReportsReportApi.
 * @export
 * @interface SaaSReportsReportApiSaaSReportsDailyStaffingSheetGetRequest
 */
export interface SaaSReportsReportApiSaaSReportsDailyStaffingSheetGetRequest {
  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsDailyStaffingSheetGet
   */
  readonly departmentId: number;

  /**
   *
   * @type {string}
   * @memberof SaaSReportsReportApiSaaSReportsDailyStaffingSheetGet
   */
  readonly date: string;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsDailyStaffingSheetGet
   */
  readonly facilityID?: number;

  /**
   *
   * @type {ReportTaFileFormat}
   * @memberof SaaSReportsReportApiSaaSReportsDailyStaffingSheetGet
   */
  readonly format?: ReportTaFileFormat;

  /**
   *
   * @type {ReportTaGroupBy}
   * @memberof SaaSReportsReportApiSaaSReportsDailyStaffingSheetGet
   */
  readonly groupBy?: ReportTaGroupBy;

  /**
   *
   * @type {ReportTaOrientation}
   * @memberof SaaSReportsReportApiSaaSReportsDailyStaffingSheetGet
   */
  readonly orientation?: ReportTaOrientation;

  /**
   *
   * @type {string}
   * @memberof SaaSReportsReportApiSaaSReportsDailyStaffingSheetGet
   */
  readonly header?: string;

  /**
   *
   * @type {string}
   * @memberof SaaSReportsReportApiSaaSReportsDailyStaffingSheetGet
   */
  readonly footer?: string;

  /**
   *
   * @type {boolean}
   * @memberof SaaSReportsReportApiSaaSReportsDailyStaffingSheetGet
   */
  readonly hppdByPosition?: boolean;

  /**
   *
   * @type {boolean}
   * @memberof SaaSReportsReportApiSaaSReportsDailyStaffingSheetGet
   */
  readonly compact?: boolean;
}

/**
 * Request parameters for saaSReportsMasterScheduleGet operation in SaaSReportsReportApi.
 * @export
 * @interface SaaSReportsReportApiSaaSReportsMasterScheduleGetRequest
 */
export interface SaaSReportsReportApiSaaSReportsMasterScheduleGetRequest {
  /**
   *
   * @type {string}
   * @memberof SaaSReportsReportApiSaaSReportsMasterScheduleGet
   */
  readonly startDate: string;

  /**
   *
   * @type {string}
   * @memberof SaaSReportsReportApiSaaSReportsMasterScheduleGet
   */
  readonly endDate: string;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsMasterScheduleGet
   */
  readonly departmentId: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsMasterScheduleGet
   */
  readonly shiftTypeId?: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsMasterScheduleGet
   */
  readonly unitId?: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsMasterScheduleGet
   */
  readonly positionId?: number;

  /**
   *
   * @type {ReportTaFileFormat}
   * @memberof SaaSReportsReportApiSaaSReportsMasterScheduleGet
   */
  readonly format?: ReportTaFileFormat;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsMasterScheduleGet
   */
  readonly orderBy?: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsMasterScheduleGet
   */
  readonly facilityId?: number;
}

/**
 * Request parameters for saaSReportsMonthlyPrintGet operation in SaaSReportsReportApi.
 * @export
 * @interface SaaSReportsReportApiSaaSReportsMonthlyPrintGetRequest
 */
export interface SaaSReportsReportApiSaaSReportsMonthlyPrintGetRequest {
  /**
   *
   * @type {string}
   * @memberof SaaSReportsReportApiSaaSReportsMonthlyPrintGet
   */
  readonly startDate: string;

  /**
   *
   * @type {string}
   * @memberof SaaSReportsReportApiSaaSReportsMonthlyPrintGet
   */
  readonly endDate: string;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsMonthlyPrintGet
   */
  readonly departmentId: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsMonthlyPrintGet
   */
  readonly shiftTypeId?: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsMonthlyPrintGet
   */
  readonly unitId?: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsMonthlyPrintGet
   */
  readonly positionId?: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsMonthlyPrintGet
   */
  readonly employeeId?: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsMonthlyPrintGet
   */
  readonly facilityId?: number;

  /**
   *
   * @type {ReportTaFileFormat}
   * @memberof SaaSReportsReportApiSaaSReportsMonthlyPrintGet
   */
  readonly format?: ReportTaFileFormat;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsMonthlyPrintGet
   */
  readonly orderBy?: number;
}

/**
 * Request parameters for saaSReportsPrintDashboardGet operation in SaaSReportsReportApi.
 * @export
 * @interface SaaSReportsReportApiSaaSReportsPrintDashboardGetRequest
 */
export interface SaaSReportsReportApiSaaSReportsPrintDashboardGetRequest {
  /**
   *
   * @type {string}
   * @memberof SaaSReportsReportApiSaaSReportsPrintDashboardGet
   */
  readonly date: string;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsPrintDashboardGet
   */
  readonly departmentId?: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsPrintDashboardGet
   */
  readonly positionId?: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsPrintDashboardGet
   */
  readonly facilityId?: number;

  /**
   *
   * @type {ReportTaFileFormat}
   * @memberof SaaSReportsReportApiSaaSReportsPrintDashboardGet
   */
  readonly format?: ReportTaFileFormat;
}

/**
 * Request parameters for saaSReportsPrintEmployeeViewGet operation in SaaSReportsReportApi.
 * @export
 * @interface SaaSReportsReportApiSaaSReportsPrintEmployeeViewGetRequest
 */
export interface SaaSReportsReportApiSaaSReportsPrintEmployeeViewGetRequest {
  /**
   *
   * @type {string}
   * @memberof SaaSReportsReportApiSaaSReportsPrintEmployeeViewGet
   */
  readonly startDate?: string;

  /**
   *
   * @type {string}
   * @memberof SaaSReportsReportApiSaaSReportsPrintEmployeeViewGet
   */
  readonly endDate?: string;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsPrintEmployeeViewGet
   */
  readonly schedulePeriodId?: number;

  /**
   *
   * @type {boolean}
   * @memberof SaaSReportsReportApiSaaSReportsPrintEmployeeViewGet
   */
  readonly usingSchedulePeriod?: boolean;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsPrintEmployeeViewGet
   */
  readonly employeeId?: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsPrintEmployeeViewGet
   */
  readonly facilityId?: number;
}

/**
 * Request parameters for saaSReportsPrintMasterSchedulePlannerGet operation in SaaSReportsReportApi.
 * @export
 * @interface SaaSReportsReportApiSaaSReportsPrintMasterSchedulePlannerGetRequest
 */
export interface SaaSReportsReportApiSaaSReportsPrintMasterSchedulePlannerGetRequest {
  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsPrintMasterSchedulePlannerGet
   */
  readonly departmentId: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsPrintMasterSchedulePlannerGet
   */
  readonly shiftTypeId?: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsPrintMasterSchedulePlannerGet
   */
  readonly positionId?: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsPrintMasterSchedulePlannerGet
   */
  readonly masterScheduleDraftId?: number;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsPrintMasterSchedulePlannerGet
   */
  readonly facilityId?: number;

  /**
   *
   * @type {ReportTaFileFormat}
   * @memberof SaaSReportsReportApiSaaSReportsPrintMasterSchedulePlannerGet
   */
  readonly format?: ReportTaFileFormat;

  /**
   *
   * @type {number}
   * @memberof SaaSReportsReportApiSaaSReportsPrintMasterSchedulePlannerGet
   */
  readonly numberOfWeeks?: number;

  /**
   *
   * @type {ReportTaSortEnum}
   * @memberof SaaSReportsReportApiSaaSReportsPrintMasterSchedulePlannerGet
   */
  readonly unitSort?: ReportTaSortEnum;

  /**
   *
   * @type {string}
   * @memberof SaaSReportsReportApiSaaSReportsPrintMasterSchedulePlannerGet
   */
  readonly search?: string;
}

/**
 * SaaSReportsReportApi - object-oriented interface
 * @export
 * @class SaaSReportsReportApi
 * @extends {BaseAPI}
 */
export class SaaSReportsReportApi extends BaseAPI {
  /**
   *
   * @param {SaaSReportsReportApiSaaSReportsAvailableSchedulesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SaaSReportsReportApi
   */
  public saaSReportsAvailableSchedulesGet(
    requestParameters: SaaSReportsReportApiSaaSReportsAvailableSchedulesGetRequest,
    options?: AxiosRequestConfig
  ) {
    return SaaSReportsReportApiFp(this.configuration)
      .saaSReportsAvailableSchedulesGet(
        requestParameters.departmentId,
        requestParameters.shiftTypeId,
        requestParameters.positionId,
        requestParameters.startDate,
        requestParameters.endDate,
        requestParameters.format,
        requestParameters.displayTotals,
        requestParameters.availableCountCompareBy,
        requestParameters.facilityId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary GetDaily Staffing Sheet
   * @param {SaaSReportsReportApiSaaSReportsDailyStaffingSheetGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SaaSReportsReportApi
   */
  public saaSReportsDailyStaffingSheetGet(
    requestParameters: SaaSReportsReportApiSaaSReportsDailyStaffingSheetGetRequest,
    options?: AxiosRequestConfig
  ) {
    return SaaSReportsReportApiFp(this.configuration)
      .saaSReportsDailyStaffingSheetGet(
        requestParameters.departmentId,
        requestParameters.date,
        requestParameters.facilityID,
        requestParameters.format,
        requestParameters.groupBy,
        requestParameters.orientation,
        requestParameters.header,
        requestParameters.footer,
        requestParameters.hppdByPosition,
        requestParameters.compact,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Generates Master-Schedule report
   * @param {SaaSReportsReportApiSaaSReportsMasterScheduleGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SaaSReportsReportApi
   */
  public saaSReportsMasterScheduleGet(
    requestParameters: SaaSReportsReportApiSaaSReportsMasterScheduleGetRequest,
    options?: AxiosRequestConfig
  ) {
    return SaaSReportsReportApiFp(this.configuration)
      .saaSReportsMasterScheduleGet(
        requestParameters.startDate,
        requestParameters.endDate,
        requestParameters.departmentId,
        requestParameters.shiftTypeId,
        requestParameters.unitId,
        requestParameters.positionId,
        requestParameters.format,
        requestParameters.orderBy,
        requestParameters.facilityId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Monthly print report.
   * @param {SaaSReportsReportApiSaaSReportsMonthlyPrintGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SaaSReportsReportApi
   */
  public saaSReportsMonthlyPrintGet(
    requestParameters: SaaSReportsReportApiSaaSReportsMonthlyPrintGetRequest,
    options?: AxiosRequestConfig
  ) {
    return SaaSReportsReportApiFp(this.configuration)
      .saaSReportsMonthlyPrintGet(
        requestParameters.startDate,
        requestParameters.endDate,
        requestParameters.departmentId,
        requestParameters.shiftTypeId,
        requestParameters.unitId,
        requestParameters.positionId,
        requestParameters.employeeId,
        requestParameters.facilityId,
        requestParameters.format,
        requestParameters.orderBy,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Dashboard Print Report
   * @param {SaaSReportsReportApiSaaSReportsPrintDashboardGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SaaSReportsReportApi
   */
  public saaSReportsPrintDashboardGet(
    requestParameters: SaaSReportsReportApiSaaSReportsPrintDashboardGetRequest,
    options?: AxiosRequestConfig
  ) {
    return SaaSReportsReportApiFp(this.configuration)
      .saaSReportsPrintDashboardGet(
        requestParameters.date,
        requestParameters.departmentId,
        requestParameters.positionId,
        requestParameters.facilityId,
        requestParameters.format,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SaaSReportsReportApiSaaSReportsPrintEmployeeViewGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SaaSReportsReportApi
   */
  public saaSReportsPrintEmployeeViewGet(
    requestParameters: SaaSReportsReportApiSaaSReportsPrintEmployeeViewGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return SaaSReportsReportApiFp(this.configuration)
      .saaSReportsPrintEmployeeViewGet(
        requestParameters.startDate,
        requestParameters.endDate,
        requestParameters.schedulePeriodId,
        requestParameters.usingSchedulePeriod,
        requestParameters.employeeId,
        requestParameters.facilityId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Master Schedule Planner Print Report
   * @param {SaaSReportsReportApiSaaSReportsPrintMasterSchedulePlannerGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SaaSReportsReportApi
   */
  public saaSReportsPrintMasterSchedulePlannerGet(
    requestParameters: SaaSReportsReportApiSaaSReportsPrintMasterSchedulePlannerGetRequest,
    options?: AxiosRequestConfig
  ) {
    return SaaSReportsReportApiFp(this.configuration)
      .saaSReportsPrintMasterSchedulePlannerGet(
        requestParameters.departmentId,
        requestParameters.shiftTypeId,
        requestParameters.positionId,
        requestParameters.masterScheduleDraftId,
        requestParameters.facilityId,
        requestParameters.format,
        requestParameters.numberOfWeeks,
        requestParameters.unitSort,
        requestParameters.search,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
